export default __webpack_public_path__ + "static/media/wookai-setup.309a3365.png";